import { render } from "./TvmSlideOutResearchModels.vue?vue&type=template&id=e94aabda&scoped=true"
import script from "./TvmSlideOutResearchModels.vue?vue&type=script&lang=js"
export * from "./TvmSlideOutResearchModels.vue?vue&type=script&lang=js"

import "./TvmSlideOutResearchModels.vue?vue&type=style&index=0&id=e94aabda&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e94aabda"]])

export default __exports__